<template>
    <v-dialog v-model="ui.show" persistent>
        <v-card>
            <v-toolbar dense color="primary" dark align="center">
                <v-row>                        
                    <v-col cols="5" align="left">
                        <v-toolbar-title>Risultati Query</v-toolbar-title>
                    </v-col>
                    <v-col cols="2" />
                    <v-col cols="5" align="right">
                        <v-btn small light @click="close">
                            <v-icon color="error">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-container v-if="ui.error == null && data !=null">
                <v-tabs centered v-model="ui.tabs" color="primary">
                    <v-tab>Import in connext_default</v-tab>
                    <v-tab>Import in connext_extra</v-tab>
                    <v-tab v-for="(result, i) in select_results" :key="i">Risultato select {{i+1}}</v-tab>
                </v-tabs>
                <v-tabs-items v-model="ui.tabs">
                    <v-tab-item v-for="(item, i) in data" :key="i">
                        <v-data-table :headers="getTableHeaders(item)" :items="item" />
                    </v-tab-item>
                </v-tabs-items>
            </v-container>
            <v-container v-else>
                <v-card-text>{{ui.error}}</v-card-text>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name:'DialogTestImportQuery',
    data(){
        return{
            data : null,
            import_results : null,
            select_results : null,
            ui : {
                error : null,
                show : false,
                tabs : 0
            }
        }
    },
    methods: {
        close(){
            this.ui.show = false;
            this.ui.tabs = 0;
            this.import_results = null;
            this.select_results = null;
            this.ui.error = null;
            this.data = null;
        },
        getTableHeaders(table){
            const headers_obj = new Object();
            const length = table.length;
            for(let i=0; i<length; i++){
                const item = table[i];
                const item_keys = Object.keys(item);
                for(let j=0; j<item_keys.length; j++){
                    const key = item_keys[j].toLowerCase().trim();
                    headers_obj[key] = null;
                }
            }
            const headers_list = Object.keys(headers_obj);
            const headers = new Array();
            for(let i=0; i<headers_list.length; i++){
                const header = headers_list[i];
                headers.push({ text:header, value:header, sortable:false});
            }
            return headers;
        },
        show(data){
            this.import_results = data.import_results;
            this.select_results = data.select_results;
            const merged = [data.import_results.default, data.import_results.extra ];
            for(let i=0; i < data.select_results.length; i++){
                merged.push(data.select_results[i]);
            }
            this.data = merged;
            this.ui.show = true;
        },
        showError(error){
            this.ui.error = error;
            this.ui.show = true;
        }
    }
}
</script>